/* eslint-disable react/jsx-no-literals */
import { CardBody } from '@m/alchemy-ui';
import { CardHeaderStyled, CardStyled, ErrorContainer, ErrorTitle } from './StatusErrorCard.styled';

interface StatusErrorCardProps {
  error: string;
}

export const StatusErrorCard = ({ error }: StatusErrorCardProps) => (
  <>
    <ErrorContainer data-testid="status-error-card">
      <CardStyled>
        <CardHeaderStyled>
          <ErrorTitle>Error Occurred</ErrorTitle>
        </CardHeaderStyled>
        <CardBody>{error}</CardBody>
      </CardStyled>
    </ErrorContainer>
  </>
);
